import React, { useState, useEffect, useRef } from 'react';

const MESSAGES = [
  "Warming up the field...",
  "Lacing up for your game...",
  "Calling players to the pitch...",
  "Loading your sports world...",
  "Getting your stats ready...",
  "Building your team roster...",
  "Preparing the scoreboard...",
  "The game is about to begin...",
  "Connecting your sports community...",
  "Setting up the tournament bracket...",
];

const GlobalLoadingOverlay = () => {
  const [visible, setVisible] = useState(false);
  const [msgIndex, setMsgIndex] = useState(0);
  const msgTimer = useRef(null);

  useEffect(() => {
    const onStart = () => {
      setMsgIndex(Math.floor(Math.random() * MESSAGES.length));
      setVisible(true);

      msgTimer.current = setInterval(() => {
        setMsgIndex(i => (i + 1) % MESSAGES.length);
      }, 2200);
    };

    const onEnd = () => {
      clearInterval(msgTimer.current);
      setVisible(false);
    };

    window.addEventListener('api:slow-start', onStart);
    window.addEventListener('api:slow-end', onEnd);
    return () => {
      window.removeEventListener('api:slow-start', onStart);
      window.removeEventListener('api:slow-end', onEnd);
      clearInterval(msgTimer.current);
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center"
      style={{
        background: 'rgba(0,0,0,0.82)',
        backdropFilter: 'blur(6px)',
      }}
    >
      {/* Logo */}
      <div className="flex items-center gap-x-3 mb-8">
        <img src="/favicon.png" alt="Kynaix Sports" className="w-14 h-14 object-contain rounded-2xl shadow-lg" />
        <span
          className="text-4xl font-black tracking-tight"
          style={{ background: 'linear-gradient(90deg, #2196F3, #9C4DCC, #FF9800)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}
        >
          Kynaix Sports
        </span>
      </div>

      {/* Animated bar */}
      <div className="w-48 h-1 rounded-full overflow-hidden mb-8" style={{ background: 'rgba(255,255,255,0.15)' }}>
        <div
          className="h-full rounded-full"
          style={{
            background: 'linear-gradient(90deg, #2196F3, #9C4DCC, #FF9800)',
            animation: 'kynaixSlide 1.4s ease-in-out infinite',
          }}
        />
      </div>

      {/* Rotating message */}
      <p
        key={msgIndex}
        className="text-white text-base font-medium tracking-wide"
        style={{ animation: 'kynaixFadeIn 0.5s ease' }}
      >
        {MESSAGES[msgIndex]}
      </p>

      <style>{`
        @keyframes kynaixSlide {
          0%   { width: 0%;   margin-left: 0%; }
          50%  { width: 70%;  margin-left: 15%; }
          100% { width: 0%;   margin-left: 100%; }
        }
        @keyframes kynaixFadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default GlobalLoadingOverlay;
